// @flow

import * as React from 'react';

import { Info } from 'lucide-react';

import { selectCartUUID, type ProductId } from '@gandi/cart';
import { useTranslator } from '@gandi/translate';
import { Base, Badge, Button } from '@gandi/ui';

import { useAppSelector } from 'src/hooks/useAppSelector';

import { ListRow } from '../../../../ListRow';

export type Props = {
  productId: ProductId,
  hasValidSmdFile: boolean,
  productSmdData: string,
};

export default function SmdFileRow({
  hasValidSmdFile,
  productId,
  productSmdData,
}: Props): React.MixedElement {
  const { __ } = useTranslator();
  const cartId = useAppSelector(selectCartUUID);
  const uploadButtonLabel = productSmdData !== '' ? __('Change') : __('Upload');

  const listRowProps = {
    icon: !hasValidSmdFile && <Info size={20} />,
    cta: !hasValidSmdFile && (
      <Button
        kind="link"
        type="button"
        to={`/cart/${cartId}/configure/${productId}/smd`}
      >
        {uploadButtonLabel}
      </Button>
    ),

    intent: !hasValidSmdFile ? 'warning' : 'muted',
  };

  return (
    <ListRow {...listRowProps}>
      <Base flex gap="spacing-2x" flexAlignItemsCenter>
        {__('Trademark claim')}
        {!hasValidSmdFile && !productSmdData && (
          <Badge intent="warning">{__('SMD Mandatory')}</Badge>
        )}
        {productSmdData !== '' &&
          (hasValidSmdFile ? (
            <Badge intent="success">{__('SMD checked')}</Badge>
          ) : (
            <Badge intent="warning">{__('SMD Invalid')}</Badge>
          ))}
      </Base>
    </ListRow>
  );
}
